module.exports = __webpack_public_path__ + "static/media/forward.365cee59.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/forward.svg
// module id = 1943
// module chunks = 0